import { Card } from "@/components/ui/card";
import { Star } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem } from "@/components/ui/carousel";
import Autoplay from "embla-carousel-autoplay";
import { useRef } from "react";
const Testimonials = () => {
  const testimonials = [{
    name: "Alpana",
    text: "Working with Nikita has been life changing. My gut issues have been resolved to a significant extent, my allergies have reduced, and I finally have the energy that I have been missing for so long..",
    rating: 5
  }, {
    name: "Nidhi",
    text: "Nikita's personalised approach has helped me understand my body's unique rhythm and needs. The results have been incredible - better sleep, no brain fog and sustained energy throughout the day.",
    rating: 5
  }, {
    name: "Shail",
    text: "The transformation has been remarkable. I feel more energetic, my morning stiffness has gone, and I have learnt to listen to what my body truly needs.",
    rating: 4
  }, {
    name: "Natasha",
    text: "The results experienced by me speak for themselves. I have never felt better, and the sustainable approach means these changes are a lifestyle change that I can easily follow.",
    rating: 5
  }, {
    name: "Shalina",
    text: "Nikita's holistic approach gave me clarity on nutrition and her personalised nutrition and supplements plan was exactly what I needed to deal with my hormonal issues.",
    rating: 5
  }, {
    name: "Aditi",
    text: "I was skeptical at first, but Nikita's functional nutrition approach addressed issues that traditional methods couldn't. I'm grateful for her guidance and expertise.",
    rating: 5
  }];

  // Duplicate array for continuous illusion
  const duplicatedTestimonials = [...testimonials, ...testimonials, ...testimonials];
  const autoplayPlugin = useRef(Autoplay({
    delay: 1,
    // minimal delay — movement speed controlled by duration below
    stopOnInteraction: false,
    stopOnMouseEnter: false
  }));
  return <section className="section-padding overflow-hidden bg-[#f7f4ed]">
      <div className="container-custom space-y-8 sm:space-y-12">
        <div className="text-center space-y-2 px-4">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-foreground">
            Client Testimonials
          </h2>
          <p className="text-base sm:text-lg text-muted-foreground">
            Real stories from real people
          </p>
        </div>

        <div className="relative">
          {/* Fade edges */}
          <div className="absolute left-0 top-0 bottom-0 w-12 sm:w-20 md:w-32 bg-gradient-to-r from-background to-transparent z-10 pointer-events-none" />
          <div className="absolute right-0 top-0 bottom-0 w-12 sm:w-20 md:w-32 bg-gradient-to-l from-background to-transparent z-10 pointer-events-none" />

          <Carousel opts={{
          align: "start",
          loop: true,
          dragFree: true,
          containScroll: false,
          duration: 9000 // Smooth continuous speed (higher = slower)
        }} plugins={[autoplayPlugin.current]} className="w-full cursor-grab active:cursor-grabbing">
            <CarouselContent className="-ml-4 sm:-ml-6" onPointerDown={() => autoplayPlugin.current.stop()} // stop while dragging
          onPointerUp={() => autoplayPlugin.current.play()} // resume after release
          onMouseEnter={() => autoplayPlugin.current.stop()} onMouseLeave={() => autoplayPlugin.current.play()}>
              {duplicatedTestimonials.map((testimonial, index) => <CarouselItem key={index} className="pl-4 sm:pl-6 basis-[260px] sm:basis-[300px] md:basis-[380px]">
                  <Card className="card-enhanced p-5 sm:p-6 md:p-8 space-y-3 sm:space-y-4 
                               border-border transition-all duration-300 hover:scale-105 
                               hover:shadow-lg select-none h-full">
                    <div className="flex gap-1">
                      {[...Array(testimonial.rating)].map((_, i) => <Star key={i} className="w-4 h-4 md:w-5 md:h-5 fill-accent text-accent" />)}
                    </div>
                    <p className="text-sm md:text-base text-card-foreground leading-relaxed italic">
                      "{testimonial.text}"
                    </p>
                    <p className="font-semibold text-card-foreground text-sm md:text-base">
                      — {testimonial.name}
                    </p>
                  </Card>
                </CarouselItem>)}
            </CarouselContent>
          </Carousel>
        </div>
      </div>
    </section>;
};
export default Testimonials;